/** Status banner for the billing page (sandbox, checkout result, provider errors) on theme tokens */

import type { LucideIcon } from 'lucide-react'
import { cn } from '../../lib/utils'

export type BannerTone = 'accent' | 'success' | 'neutral' | 'warning' | 'danger'

const TONES: Record<BannerTone, { box: string; icon: string }> = {
  accent: { box: 'border-accent/30 bg-accent-soft', icon: 'text-accent-text' },
  success: { box: 'border-success/30 bg-success-soft', icon: 'text-success' },
  neutral: { box: 'border-border bg-surface-muted', icon: 'text-fg-subtle' },
  warning: { box: 'border-warning/30 bg-warning-soft', icon: 'text-warning' },
  danger: { box: 'border-danger/30 bg-danger-soft', icon: 'text-danger' },
}

interface Props {
  tone: BannerTone
  icon: LucideIcon
  title: string
  body?: string
}

export function BillingBanner({ tone, icon: Icon, title, body }: Props) {
  const styles = TONES[tone]
  return (
    <div
      role={tone === 'danger' || tone === 'warning' ? 'alert' : 'status'}
      className={cn('flex items-start gap-3 rounded-lg border p-4', styles.box)}
    >
      <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', styles.icon)} aria-hidden="true" />
      <div className="min-w-0">
        <p className="text-sm font-medium text-fg">{title}</p>
        {body && <p className="mt-0.5 text-sm text-fg-muted">{body}</p>}
      </div>
    </div>
  )
}
